import { EntityBranchGoal } from "../entity/EntityBranchGoal";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoGoalsGetRes } from "./abst/DtoGoalsGetRes";

export class DtoBranchGoalsGetRes  extends EntityBranchGoal {
  public items: EntityBranchGoal[]  = [];
  public pager = new DtoApiPager();
}
